// extracted by mini-css-extract-plugin
module.exports = {"root":"Navbar_root__3TNwv","leftSide":"Navbar_leftSide__2cGDz","rightSide":"Navbar_rightSide__3e9u5","logo":"Navbar_logo__1O85f"};